module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/535f3a7d219eb20cefe55747d9e72749.png";